import React, { useState } from 'react';

const LoginView = ({ API_URL, onSuccess }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mode, setMode] = useState('login'); // 'login' | 'forgot' | 'reset'
  const [forgotIdent, setForgotIdent] = useState('');
  const [resetLogin, setResetLogin] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [resetPass, setResetPass] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, password })
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || 'Login failed');
      }
      const body = await res.json();
      onSuccess(body.token, body.user);
    } catch (e) {
      setError(e.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const baseUrl = (import.meta.env.BASE_URL || '/');
  const bgUrl = `${baseUrl.replace(/\/+$/, '/') }glasses.jpg`;
  const bgStyle = {
    ...outer,
    backgroundImage: `url(${bgUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  const logoName = (import.meta.env.COMPANY_LOGO || 'company_logo.png');
  const logoUrl = `${baseUrl.replace(/\/+$/, '/')}${logoName.replace(/^\/+/, '')}`;

  return (
    <div style={bgStyle}>
      <div style={card}>
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <img src={logoUrl} alt="Company" style={{ maxWidth: 180, height: 'auto' }} />
        </div>
        <h2 style={{ marginTop: 0, textAlign: 'center' }}>{mode === 'login' ? 'Sign in' : mode === 'forgot' ? 'Forgot Password' : 'Reset Password'}</h2>
        {error && (
          <div style={{ background: '#fdecea', color: '#b71c1c', padding: 8, borderRadius: 4, marginBottom: 10 }}>
            {error}
          </div>
        )}
        {mode === 'login' && (
          <form onSubmit={handleSubmit}>
            <div style={row}>
              <label style={label}>Login</label>
              <input style={input} value={login} onChange={e => setLogin(e.target.value)} autoFocus />
            </div>
            <div style={row}>
              <label style={label}>Password</label>
              <input type="password" style={input} value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <button type="submit" style={button} disabled={loading}>{loading ? 'Signing in…' : 'Sign In'}</button>
            <div style={{ marginTop: 8, textAlign: 'right' }}>
              <button type="button" className="btn btn-ghost" onClick={() => { setError(''); setMode('forgot'); setForgotIdent(login || ''); }}>Forgot password?</button>
            </div>
          </form>
        )}
        {mode === 'forgot' && (
          <form onSubmit={async (e) => {
            e.preventDefault(); setLoading(true); setError('');
            try {
              const res = await fetch(`${API_URL}/auth/forgot`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ login: forgotIdent }) });
              if (!res.ok) throw new Error('Failed to send reset code');
              alert('If an account exists, a reset code has been emailed.');
              setResetLogin(forgotIdent); setMode('reset');
            } catch (e) { setError(e.message || 'Failed to send reset code'); }
            finally { setLoading(false); }
          }}>
            <div style={row}>
              <label style={label}>Login or Email</label>
              <input style={input} value={forgotIdent} onChange={e => setForgotIdent(e.target.value)} autoFocus />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button type="submit" style={{ ...button, flex: 1 }} disabled={loading}>{loading ? 'Sending…' : 'Send Code'}</button>
              <button type="button" className="btn btn-clear" onClick={() => setMode('login')}>Back</button>
            </div>
          </form>
        )}
        {mode === 'reset' && (
          <form onSubmit={async (e) => {
            e.preventDefault(); setLoading(true); setError('');
            try {
              const res = await fetch(`${API_URL}/auth/reset`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ login: resetLogin, code: resetCode, password: resetPass }) });
              const body = await res.json().catch(()=>({}));
              if (!res.ok || body?.ok !== true) throw new Error(body.message || 'Failed to reset password');
              alert('Password reset successful. Please sign in.');
              setMode('login'); setPassword(''); setLogin(resetLogin);
            } catch (e) { setError(e.message || 'Failed to reset password'); }
            finally { setLoading(false); }
          }}>
            <div style={row}>
              <label style={label}>Login</label>
              <input style={input} value={resetLogin} onChange={e => setResetLogin(e.target.value)} autoFocus />
            </div>
            <div style={row}>
              <label style={label}>Code</label>
              <input style={input} value={resetCode} onChange={e => setResetCode(e.target.value)} />
            </div>
            <div style={row}>
              <label style={label}>New Password</label>
              <input type="password" style={input} value={resetPass} onChange={e => setResetPass(e.target.value)} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button type="submit" style={{ ...button, flex: 1 }} disabled={loading}>{loading ? 'Resetting…' : 'Reset Password'}</button>
              <button type="button" className="btn btn-clear" onClick={() => setMode('login')}>Back</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

const outer = { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', background: 'var(--bg)' };
const card = { width: 360, maxWidth: '92vw', background: 'var(--card-bg)', color: 'var(--text)', borderRadius: 8, boxShadow: '0 6px 24px rgba(0,0,0,0.18)', padding: 18 };
const row = { display: 'flex', flexDirection: 'column', marginBottom: 10 };
const label = { fontSize: 12, color: 'var(--text)', marginBottom: 4 };
const input = { padding: '10px 12px', borderRadius: 6, border: '1px solid var(--border-soft)', background: 'var(--input-bg)', color: 'var(--text)' };
const button = { width: '100%', padding: '10px 12px', background: 'var(--primary)', color: 'var(--primary-contrast)', border: 'none', borderRadius: 6, cursor: 'pointer', marginTop: 8 };

export default LoginView;
